import React from "react"
import Layout from "../components/Layout"
import Marquee from "../components/Home/Marquee"
import WhatWeDo from "../components/Home/WhatWeDo"
import WhoAreYou from "../components/Home/WhoAreYou"
import AllSet from "../components/Home/AllSet"
import ABetterWay from "../components/Home/ABetterWay"

export default function Home() {
  return (
    <Layout 
      title="Shopify Systems: Leaders in Design and Development"
      subtitle="Your one-stop-shop for Shopify stores"
      home="home"
    >
       
       <Marquee />
       <WhatWeDo />
       <WhoAreYou /> 
       <AllSet />
       <ABetterWay />
    </Layout>
  )
}


